let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1gTGZ")).then(() => parcelRequire('7O8th'));